import React, { useEffect } from 'react';

const Loading = ({ status, blur = false, children }) => {

  useEffect(() => {
    if (status) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }

    return () => {
      document.body.style.overflow = '';
    };
  }, [status]);


  if (status) {
    if (blur) {
      return (
        <div className="position-relative">
          <div
            style={{
              filter: 'blur(5px)',
              opacity: 0.5,
              pointerEvents: 'none', 
            }}
          >
            {children}
          </div>

          <div
            className="d-flex justify-content-center align-items-center position-fixed top-0 start-0 w-100 h-100"
            style={{
              background: 'rgba(0, 0, 0, 0.2)', 
              zIndex: 1050, 
            }}
          >
            <div className="spinner-border text-light" role="status" aria-label="Loading">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        </div>
      );
    }

    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: '100%', minHeight: '200px', width: '100%' }}
      >
        <div className="spinner-border text-light" role="status" aria-label="Loading">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  return <>{children}</>;
};

export default Loading;
